var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 87",
    width: 97,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-150-1789h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#c9f0fe}.b{fill:#9be8fd}.c{fill:#b0e7af}.d{fill:#92df93}.e{fill:#73d578}.f{fill:#4bce5b}.g{fill:#8479c2}.h{fill:#6e60b8}.i{fill:#ffc365}.j{fill:#ffa90f}.k{fill:#ff9b00}.l{fill:#ffd086}.m{fill:#00b426}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m96.7 18.5v-4.8c0-2.3-1.9-4.3-4.3-4.3h-49.3l-0.8 0.8v6.1l0.8 2.2-0.8 0.9v7.9l0.8 1.1-0.8 1.5v11.3h40l2.1 2.3v12.1l1.8 1.8h6.2c2.4 0 4.3-1.9 4.3-4.3v-24.7l-1.3-1.2v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m43.1 9.4h-11.5l-1.2 1.8v30h12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m84.4 52.6l-7.9-6-3.8-4.3-1.7-3.3h-43.3l-3 0.2-3.3 4.6v38.9l4 3.8 1.2 0.4 0.7 0.1h43.7l2-1.4 10.6-11.7 2.6-2.1v-17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m21.7 79.2v-32.4c0-3.7 2.5-6.9 6-7.8h-11.8l-0.8 0.9-11.5 12-2.9 2.3v17.6l1.8 1.6 8.5 4.8 3.2 5.6 1.7 3.2h11.8c-3.5-0.9-6-4.1-6-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m49.2 48.9h-2.9l-8.1 5.3c0 0-0.9 10.6-0.9 11 0.1 0.5 3.3 8.9 3.3 8.9l2.9 2.4 5.7 0.6c5.6-2.3 9.5-7.7 9.5-14.1 0-6.4-3.9-11.8-9.5-14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m39.8 63c0-6.4 3.9-11.8 9.4-14.1-1.7-0.7-3.7-1.1-5.7-1.1-8.4 0-15.3 6.8-15.3 15.2 0 8.4 6.9 15.2 15.3 15.2 2 0 4-0.4 5.7-1.1-5.5-2.3-9.4-7.7-9.4-14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m82 39h-11c0 8.4 6.8 15.2 15.2 15.2v-10.9c0-2.4-1.9-4.3-4.2-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m82 87h-11c0-8.4 6.8-15.2 15.2-15.2v10.9c0 2.4-1.9 4.3-4.2 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m5 39h10.9c0 8.4-6.8 15.2-15.2 15.2v-10.9c0-2.4 1.9-4.3 4.3-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m5 87h10.9c0-8.4-6.8-15.2-15.2-15.2v10.9c0 2.4 1.9 4.3 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m43.1 18.5l-0.8 0.9v7.9l0.8 1.1h53.6v-9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m30.4 18.5h12.7v9.9h-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m21.6 1.5h-2.3l-8.2 4.1-2.9 6.5 1.3 14.2h20.3l1.7-0.8c1.4-2.4 2.2-5.1 2.2-8.1 0-7.6-5.2-14-12.1-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m9.4 17.4c0-7.6 5.2-14 12.2-15.9q-2.1-0.6-4.4-0.6c-9.1 0-16.5 7.4-16.5 16.5 0 3 0.8 5.7 2.1 8.1l1.5 0.8h8.7l-1.4-0.8c-1.4-2.4-2.2-5.1-2.2-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.2 11.3c-0.2-0.2-1.6-1.6-3.7-2v-1.3c0-0.8-0.6-1.4-1.4-1.4-0.8 0-1.5 0.6-1.5 1.4v1.4c-2 0.6-3.5 2.4-3.5 4.4 0 1.7 1.2 3.2 3.4 4.2 0.7 0.4 1.3 0.7 1.8 1l1 0.7q0.4 0.2 0.8 0.2c0.5 0 1-0.2 1.2-0.7 0.5-0.6 0.3-1.5-0.4-2l-1-0.6c-0.6-0.4-1.3-0.8-2.2-1.2-1.3-0.6-1.7-1.2-1.7-1.6 0-0.8 0.9-1.8 2.3-1.8 1.5 0 2.8 1.2 2.8 1.3 0.6 0.6 1.5 0.6 2 0 0.6-0.5 0.6-1.5 0.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m21.6 17.8h-3.4l-6.6 3.9-3.3 10.5v6.8c0 0 4.1 5.9 4.4 6.2 0.3 0.2 6.6 4 6.6 4l2.3 0.4c6.9-1.9 12.1-8.3 12.1-15.9 0-7.6-5.2-14-12.1-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m9.4 33.7c0-7.6 5.2-14 12.2-15.9q-2.1-0.6-4.4-0.6c-9.1 0-16.5 7.4-16.5 16.5 0 9.1 7.4 16.5 16.5 16.5q2.3 0 4.4-0.6c-7-1.9-12.2-8.3-12.2-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.8 37.2q0-3.7-4.2-4.9c-2.4-0.6-3.6-1.6-3.6-2.2 0-0.9 0.9-1.8 2.3-1.8 1.5 0 2.8 1.2 2.8 1.2 0.6 0.6 1.5 0.6 2 0.1 0.6-0.6 0.6-1.5 0.1-2.1-0.2-0.2-1.6-1.5-3.7-2v-1.2c0-0.8-0.6-1.5-1.4-1.5-0.8 0-1.5 0.7-1.5 1.5v1.3c-2 0.7-3.5 2.4-3.5 4.5 0 2.2 2.1 4.1 5.7 5 2.1 0.6 2.1 1.4 2.1 2.1 0 0.7-0.7 1.9-2.8 1.9-1.7 0-2.7-1-3-1.4-0.5-0.6-1.4-0.8-2-0.3-0.7 0.5-0.8 1.5-0.3 2.1 0.5 0.6 1.8 1.9 3.8 2.3v1.3c0 0.8 0.7 1.4 1.5 1.4 0.8 0 1.4-0.6 1.4-1.4v-1.3c2.8-0.5 4.3-2.6 4.3-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m48.8 66.3q0-3.6-4-4.6c-2.2-0.6-3.3-1.6-3.3-2 0-0.7 0.9-1.5 2.1-1.5 1.3 0 2.4 1 2.5 1.1 0.5 0.5 1.4 0.6 2 0 0.6-0.5 0.6-1.5 0.1-2-0.2-0.2-1.5-1.5-3.4-1.9v-1.1c0-0.8-0.6-1.4-1.4-1.4-0.8 0-1.5 0.6-1.5 1.4v1.2c-1.9 0.6-3.3 2.3-3.3 4.2 0 2.1 2 3.9 5.4 4.8 1.9 0.4 1.9 1.2 1.9 1.8 0 0.6-0.7 1.6-2.5 1.6-1.5 0-2.4-0.9-2.7-1.3-0.5-0.6-1.4-0.7-2-0.2-0.6 0.5-0.7 1.4-0.2 2 0.4 0.6 1.5 1.8 3.4 2.2v1.1c0 0.8 0.7 1.4 1.5 1.4 0.8 0 1.4-0.6 1.4-1.4v-1.1c2.6-0.5 4-2.5 4-4.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.faec88f73cd4a11d7ddb3b5c11c846fe.svg";
export { ForwardRef as ReactComponent };